import React from 'react';
import cn from 'classnames';
import './notificationStatusBadge.scss';
import { getNotificationStatusLabel } from 'helpers/notificationDelivery';

function NotificationStatusBadge({ status, className = '' }) {
	if (!status) return null;

	return (
		<span
			className={cn(
				'NotificationStatusBadge',
				`NotificationStatusBadge--${String(status).toLowerCase()}`,
				className,
			)}>
			{getNotificationStatusLabel(status)}
		</span>
	);
}

export default NotificationStatusBadge;
